// #region Imports
import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IonApp } from '@ionic/angular/ion-app';
// #endregion Imports

/**
 * `app-shell` — wrapper di `ion-app` (gruppo `shell` della libreria dei wrapper).
 *
 * - Tipo: shell, usato una sola volta da AppComponent (`app.component.html:5`).
 * - Elementi Ionic posseduti: `ion-app`.
 * - Contenuto: proiettato così com'è (`<ng-content>`), quindi il gate `@if (!isPageBootstrapping() &&
 *   siteTheme.isReady())` di AppComponent resta dentro lo shell come oggi resta dentro `ion-app`.
 * - Perché un `ion-app` vero dentro: gli overlay inline e da controller vengono spostati sotto
 *   `document.querySelector('ion-app')` (`@ionic/core/dist/collection/utils/framework-delegate.js:102`),
 *   e la stessa ricerca globale serve a tastiera e overlay (`utils/keyboard/keyboard-controller.js:28`,
 *   `utils/overlays.js:724`). Tutte ricerche globali: sopravvivono all'host in più.
 * - Box dell'host: `ion-app` non ha display proprio, prende `.ion-page` come classe di host
 *   (`components/app/app.js:84`) e quindi il box di `.ion-page` di core.css
 *   (`@ionic/core/css/core.css:1@col7262`: `position: absolute; inset 0; display: flex; flex-direction:
 *   column; justify-content: space-between; contain: layout size style; z-index: 0`). L'host lo copia
 *   (vedi scss); l'`ion-app` interno, assoluto con inset 0, riempie esattamente l'host posizionato.
 * - Eventi: nessuno usato. Input: nessuno (la classe di tema su `ion-app` non esiste più: i colori del sito si applicano all'avvio).
 * - Composizioni Ionic coperte: `(document) > ion-app` (framework-delegate.js:102,
 *   keyboard-controller.js:28, overlays.js:724: ricerca globale, sopravvive); `ion-app > ion-content /
 *   ion-header / ion-footer` (closest, sopravvive); `ion-modal > ion-app` (modal.js:612, il confronto
 *   riguarda il padre originale della modale, che non è mai `ion-app`).
 * - `appClass` (opz., default `undefined`) → `[class]` dell'`ion-app` interno: proprietà che Ionic
 *   ridichiara sul proprio host.
 */
// #region ComponentDecorator
@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonApp],
})
// #endregion ComponentDecorator
export class AppShellComponent {
  // #region SignalInputOutputModel
  // Classi per l'ion-app interno: ciò che Ionic ridichiara sul suo :host
  readonly appClass: InputSignal<string | undefined> = input<string | undefined>(undefined);
  // #endregion SignalInputOutputModel
}
